// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"31d6cfe0","259":"9c4a10f3","280":"daf778d9"}[chunkId] + ".chunk.css";
};